export default "__VITE_ASSET__C5nKkG52__"